const FRONTEND_MAP_DISABLED_HOSTS = [
    // Add hostnames here to force-disable the map on the frontend.
];

function normalizeHostname(value) {
    return String(value || "").trim().toLowerCase();
}

function matchesHostnameRule(hostname, rule) {
    const normalizedHostname = normalizeHostname(hostname);
    const normalizedRule = normalizeHostname(rule);

    if (!normalizedHostname || !normalizedRule) return false;
    if (normalizedHostname === normalizedRule) return true;

    if (normalizedRule.startsWith("*.")) {
        const suffix = normalizedRule.slice(1);
        return normalizedHostname.endsWith(suffix);
    }

    if (normalizedRule.endsWith(".*")) {
        const prefix = normalizedRule.slice(0, -1);
        return normalizedHostname.startsWith(prefix);
    }

    if (normalizedRule.startsWith(".")) {
        return normalizedHostname.endsWith(normalizedRule);
    }

    return false;
}

export function isMapEnabledByHostname(hostname = window.location.hostname) {
    return !FRONTEND_MAP_DISABLED_HOSTS.some((rule) => matchesHostnameRule(hostname, rule));
}

export function getRescanRequiredRoute() {
    return {
        path: "/error",
        query: {
            code: "50101",
        },
    };
}

export function getMachineConfigErrorRoute(machinePrecheckError = {}) {
    const query = {};

    if (machinePrecheckError.device_code) query.code = machinePrecheckError.device_code;
    if (machinePrecheckError.code) query.errorCode = machinePrecheckError.code;
    if (machinePrecheckError.message) query.message = machinePrecheckError.message;

    return {
        path: "/machine_config_error",
        query,
    };
}

export function getMapFallbackRoute({
    isBorrow = false,
    deviceCode,
    machinePrecheckError,
} = {}) {
    if (isBorrow) {
        return { path: "/renting_page" };
    }

    if (machinePrecheckError) {
        return getMachineConfigErrorRoute(machinePrecheckError);
    }

    if (deviceCode) {
        return { path: "/payment_select" };
    }

    return getRescanRequiredRoute();
}

export function getMapRouteOrFallback({
    mapEnabled,
    isBorrow = false,
    deviceCode,
    machinePrecheckError,
} = {}) {
    if (mapEnabled) {
        return { path: "/cabinet_map" };
    }

    return getMapFallbackRoute({
        isBorrow,
        deviceCode,
        machinePrecheckError,
    });
}

export function resolveMapFeatureState(hostname = window.location.hostname) {
    const mapEnabledByHost = isMapEnabledByHostname(hostname);

    return {
        map_enabled: mapEnabledByHost,
        map_enabled_by_host: mapEnabledByHost,
    };
}

export function shouldForceRescan({
    mapEnabled,
    deviceCode,
    path = window.location.pathname,
} = {}) {
    if (mapEnabled || deviceCode) return false;

    const exemptPaths = [
        "/error",
        "/payment_result",
        "/gateway_redirect",
        "/moyasar_redirect",
        "/recharge_redirect",
        "/bind_redirect",
        "/payment_redirect",
        "/help",
        "/report_problem",
        "/chat_with_us",
    ];

    return !exemptPaths.some((prefix) => String(path || "").startsWith(prefix));
}
